
export async function copyToClipboard(value){
  try {
    await navigator.clipboard.writeText(value)
  } catch (err) {
    prompt('Select to copy:', value) // eslint-disable-line no-alert
  }
  return true
}
